import React from "react";

import { IgTypography } from "@intelligems/ig-theme";

export const Optional = () => (
  <IgTypography color="text.secondary"> (optional)</IgTypography>
);
